import { BaseOrganizationEndpoints } from './base';
import { ResGetInvitations } from '../types/api-types';
import {
  Invitation,
  InvitationRequest,
  PendingInvitation
} from '../entities/invitation';
import { Id } from './response/id';
import { ResponseWithStatus } from './response/response_with_status';
import { PaginationOptions } from '../entities/pagination_options';

export class Invitations extends BaseOrganizationEndpoints {
  /**
   * Returns all invitations that have been sent via an organization. Use this
   * to see if invitations have been accepted, rejected, revoked, or still pending.
   * Does NOT include invitation code
   */
  async all(
    pagination: PaginationOptions = {
      cursor: null,
      limit: null
    }
  ) {
    const response = await this.requestWithStatus<ResGetInvitations>(
      'GET',
      this.paginatedEndpointUrl('/invitations', pagination)
    );
    return response;
  }

  /**
   * Returns invitation details by invitation id
   */
  async getById(invitationId: string) {
    return this.requestWithStatus<PendingInvitation>(
      'GET',
      `/invitations/${encodeURIComponent(invitationId)}`
    );
  }

  /**
   * Revoke pending invitation
   */
  async delete(invitationId: string) {
    return this.requestWithStatus<Invitation>(
      'DELETE',
      `/invitations/${encodeURIComponent(invitationId)}`
    );
  }

  /**
   * Sends an email invitation to a user to join a specific organization.
   * Role of "member" should be set by default. Optionally add team id's to
   * auto enroll user to specified teams upon acceptance of invitation.
   */
  async add(body: InvitationRequest[]): Promise<ResponseWithStatus<Id[]>> {
    return await this.requestWithStatus('POST', '/invitations', body);
  }
}
